import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronRightIcon, Share2Icon, LayoutTemplateIcon, TargetIcon, EuroIcon } from 'lucide-react';
export function Slide5Menu() {
  const [activeIndex, setActiveIndex] = useState(0);
  const menuItems = [{
    stage: 'Pre-Congress',
    name: 'Insight Snak',
    channels: 'Email, WhatsApp, banners, portals, rep links',
    format: 'Hook GIF + short Teaser Snak',
    output: 'Knowledge gaps, topic interest, early segmentation',
    price: '€4,000–€6,000'
  }, {
    stage: 'Vicinity',
    name: 'Attention Snak',
    channels: 'Airport, station, hotel, outdoor, Uber, QR',
    format: 'Hook GIF + short Teaser Snak',
    output: 'First engagement, scan source, booth intent',
    price: '€4,000–€6,000'
  }, {
    stage: 'Venue',
    name: 'Reminder Snak',
    channels: 'Screens, banners, posters, digital signage, QR',
    format: 'Hook GIF + short Teaser Snak',
    output: 'Message resonance and channel performance',
    price: '€4,000–€6,000'
  }, {
    stage: 'Aisle',
    name: 'Ice-Breaker Snak',
    channels: 'Rep iPad, booth screen, QR, touchscreen',
    format: 'Teaser Snak or short Trailer Snak',
    output: 'Specialty, interest area, conversation starter',
    price: '€6,000–€9,000'
  }, {
    stage: 'Booth',
    name: 'Conversation Snak',
    channels: 'iPad, touchscreen, rep-led discussion',
    format: 'Talk Snak with input and feedback cues',
    output: 'Preferences, objections, consent, next action',
    price: '€6,000–€10,000'
  }, {
    stage: 'Post-Congress',
    name: 'Follow-Up Snak',
    channels: 'Email, rep follow-up, CRM-triggered link, WhatsApp',
    format: 'Follow-up Snak or short Trailer Snak',
    output: 'Segmented follow-up and campaign learning',
    price: '€2,500–€4,000'
  }];
  const activeItem = menuItems[activeIndex];
  return <div className="h-full w-full bg-[#F8F9FA] text-[#2D3748] flex flex-col p-10 md:px-20 md:py-12 relative overflow-hidden" data-id="element-166">
      <header className="mb-8 max-w-4xl" data-id="element-167">
        <motion.h2 className="text-4xl md:text-5xl font-bold text-[#1A202C] mb-3" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-168">
          Choose the use case that solves the current challenge.
        </motion.h2>
        <motion.p className="text-xl text-[#4A5568] font-light" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-169">
          Each menu item can stand alone as a focused pilot. Select a stage to
          view details.
        </motion.p>
      </header>

      <main className="flex-1 flex flex-col md:flex-row gap-8 overflow-hidden" data-id="element-170">
        {/* Left Side: Menu List */}
        <div className="w-full md:w-1/3 flex flex-col gap-3" data-id="element-171">
          {menuItems.map((item, index) => {
          const isActive = index === activeIndex;
          return <motion.button key={item.stage} onClick={() => setActiveIndex(index)} className={`text-left px-6 py-4 rounded-xl transition-all duration-200 flex items-center justify-between border ${isActive ? 'bg-white border-[#E60012] shadow-md ring-1 ring-[#E60012]' : 'bg-white border-gray-100 shadow-sm hover:border-gray-300 hover:bg-gray-50'}`} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            delay: 0.1 + index * 0.05
          }} data-id="element-172">
                <div data-id="element-173">
                  <div className={`text-xs font-bold uppercase tracking-wider mb-1 ${isActive ? 'text-[#E60012]' : 'text-gray-400'}`} data-id="element-174">
                    {item.stage}
                  </div>
                  <div className={`text-lg font-semibold ${isActive ? 'text-[#1A202C]' : 'text-[#4A5568]'}`} data-id="element-175">
                    {item.name}
                  </div>
                </div>
                <ChevronRightIcon className={`w-5 h-5 ${isActive ? 'text-[#E60012]' : 'text-gray-300'}`} data-id="element-176" />
              </motion.button>;
        })}
        </div>

        {/* Right Side: Details Panel */}
        <div className="w-full md:w-2/3 h-full" data-id="element-177">
          <AnimatePresence mode="wait" data-id="element-178">
            <motion.div key={activeIndex} className="bg-white rounded-2xl shadow-sm border border-gray-100 h-full flex flex-col overflow-hidden" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.3
          }} data-id="element-179">
              <div className="bg-[#1A202C] text-white px-8 py-6 border-b-4 border-[#E60012]" data-id="element-180">
                <div className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-2" data-id="element-181">
                  {activeItem.stage}
                </div>
                <h3 className="text-3xl font-bold" data-id="element-182">{activeItem.name}</h3>
              </div>

              <div className="p-8 flex-1 flex flex-col gap-8 justify-center" data-id="element-183">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-184">
                  <div className="flex gap-4" data-id="element-185">
                    <div className="p-3 bg-gray-50 rounded-xl h-fit border border-gray-100" data-id="element-186">
                      <Share2Icon className="w-6 h-6 text-[#4A5568]" data-id="element-187" />
                    </div>
                    <div data-id="element-188">
                      <span className="text-gray-400 uppercase text-xs font-bold tracking-wider block mb-2" data-id="element-189">
                        Channels
                      </span>
                      <p className="text-[#2D3748] text-lg leading-snug" data-id="element-190">
                        {activeItem.channels}
                      </p>
                    </div>
                  </div>

                  <div className="flex gap-4" data-id="element-191">
                    <div className="p-3 bg-gray-50 rounded-xl h-fit border border-gray-100" data-id="element-192">
                      <LayoutTemplateIcon className="w-6 h-6 text-[#4A5568]" data-id="element-193" />
                    </div>
                    <div data-id="element-194">
                      <span className="text-gray-400 uppercase text-xs font-bold tracking-wider block mb-2" data-id="element-195">
                        Format
                      </span>
                      <p className="text-[#2D3748] text-lg leading-snug" data-id="element-196">
                        {activeItem.format}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-[#6B46C1]/5 rounded-xl p-6 border border-[#6B46C1]/10 flex gap-4 items-start" data-id="element-197">
                  <div className="p-3 bg-white rounded-xl shadow-sm border border-gray-100" data-id="element-198">
                    <TargetIcon className="w-6 h-6 text-[#6B46C1]" data-id="element-199" />
                  </div>
                  <div data-id="element-200">
                    <span className="text-[#6B46C1] uppercase text-xs font-bold tracking-wider block mb-2" data-id="element-201">
                      Output & Value
                    </span>
                    <p className="text-[#2D3748] text-xl font-medium" data-id="element-202">
                      {activeItem.output}
                    </p>
                  </div>
                </div>

                <div className="mt-auto pt-6 border-t border-gray-100 flex items-center justify-between" data-id="element-203">
                  <div className="flex items-center gap-3" data-id="element-204">
                    <div className="p-2 bg-[#E60012]/10 rounded-lg" data-id="element-205">
                      <EuroIcon className="w-5 h-5 text-[#E60012]" data-id="element-206" />
                    </div>
                    <span className="text-gray-500 uppercase text-xs font-bold tracking-wider" data-id="element-207">
                      Indicative Price
                    </span>
                  </div>
                  <p className="text-[#E60012] text-2xl font-bold" data-id="element-208">
                    {activeItem.price}
                  </p>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </main>

      <motion.footer className="mt-6 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.6,
      delay: 0.5
    }} data-id="element-209">
        <p className="text-[#4A5568] font-medium bg-white inline-block px-6 py-2 rounded-full shadow-sm border border-gray-100 text-sm" data-id="element-210">
          Start with one use case. Expand only if the data supports it.
        </p>
      </motion.footer>
    </div>;
}